export default __webpack_public_path__ + "static/balloon-shaved-ice-guy-e4c2932abdd688420a6e2119ad8ceedd.png";